var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{attrs:{"name":"arrow-left","color":"#000"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }